import { SearchRoundedIcon, TextField } from '@shared/components';
import debounce from 'lodash/debounce';

import { useProctoringEKycListSearchParams } from '../../hooks';

export default function ProctoringEkycSearchBox() {
  const [{ search }, { changePageNumber, changeSearch }] = useProctoringEKycListSearchParams();

  const debouncedSearch = debounce((searchString: string) => {
    changeSearch(searchString);
    changePageNumber(0);
  }, 700);

  return (
    <TextField
      defaultValue={search}
      placeholder='ค้นหาชื่อผู้เข้าสอบ'
      name='search'
      slotProps={{
        input: {
          startAdornment: <SearchRoundedIcon sx={{ color: (theme) => theme.palette.grey[500] }} />,
        },
      }}
      sx={{
        width: '300px',
        px: (theme) => theme.spacing(6),
      }}
      onChange={(event) => {
        debouncedSearch(event.target.value);
      }}
    />
  );
}
